export class ReminderData {
    id: number;
    name: string;
}

export enum Reminders {
    Referral = 'Referral reminder',
    Insurance = 'Insurance reminder'
}
